
import { Component, Vue } from "vue-property-decorator";
import { KnowledgeBaseArticle, KnowledgeBaseCategory } from "@/survey";

@Component({})
export default class KnowledgeBase extends Vue {
  articles: KnowledgeBaseArticle[] = [];
  categories: KnowledgeBaseCategory[] = [];
  query = "";
  categoryId: number | null = null;
  loading = false;

  get canCreateArticle() {
    const user = this.$store.state.authentication.currentUser;
    return user !== null && (user.admin || user.create);
  }

  get categoryOptions(): { value: number | null; text: string }[] {
    return [
      { value: null, text: "All Categories" },
      ...this.categories.map(category => ({ value: category.id as number, text: category.name }))
    ];
  }

  async created() {
    await Promise.all([this.loadCategories(), this.loadArticles()]);
  }

  async loadCategories() {
    this.categories = await Vue.prototype.$surveyClient.getKnowledgeBaseCategories(true);
  }

  async loadArticles() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.query.trim()) {
        params.query = this.query.trim();
      }
      if (this.categoryId !== null) {
        params.categoryId = this.categoryId;
      }
      this.articles = await Vue.prototype.$surveyClient.getKnowledgeBaseArticles(params);
    } finally {
      this.loading = false;
    }
  }

  badgeStyle(article: KnowledgeBaseArticle) {
    return {
      backgroundColor: article.categoryColor || "#3157b7",
      color: "#fff"
    };
  }

  excerpt(content: string) {
    if (!content) {
      return "";
    }
    const template = document.createElement("template");
    template.innerHTML = content;
    template.content.querySelectorAll("img, script, iframe, object, embed").forEach(element => element.remove());
    return (template.content.textContent || "").replace(/\s+/g, " ").trim().slice(0, 120);
  }

  tagList(article: KnowledgeBaseArticle) {
    const tags = (article.tags || "") as string;
    return tags.split(",").map((tag: string) => tag.trim()).filter((tag: string) => tag.length > 0);
  }

  formatDate(value: number) {
    return new Date(value).toLocaleDateString();
  }
}
